import { useTranslation } from "react-i18next"
import cn from "classnames"

import { ReactComponent as LoaderIcon } from "../../../src/assets/images/screensharing/icons/loader.svg"
import styles from "./CommonLoader.module.scss"
import { testId } from "../../utility/tests/testId/common"
import { COMMON_LOADER_CONST } from "./CommonLoader.const"

type ScreensharingLoaderProps = {
    className?: string
    dataTestId?: string
    loadingMessage?: string
}

const { tNamespace, tPath } = COMMON_LOADER_CONST

const CommonLoader = (props: ScreensharingLoaderProps) => {
    const { t } = useTranslation(tNamespace)
    const { className, loadingMessage = t(tPath.loading), dataTestId = testId.loader } = props

    return (
        <div className={cn(styles.loader, className)} data-testid={dataTestId}>
            <LoaderIcon className={styles.loader__icon} />
            <span className={styles.loader__text}>{loadingMessage}</span>
        </div>
    )
}

export default CommonLoader
